// This icon file is generated automatically.
var PMehOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.5 5.58a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm5.5 0a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM7 0a7 7 0 100 14A7 7 0 007 0zm4.1 11.1a5.81 5.81 0 11-8.22-8.2 5.81 5.81 0 018.23 8.2zM9.39 7.84H4.62a.13.13 0 00-.12.12v.75c0 .07.06.13.13.13h4.75c.06 0 .12-.06.12-.13v-.75a.13.13 0 00-.13-.12z", "fill-rule": "nonzero" } }] }, "name": "p-meh", "theme": "outlined" };
export default PMehOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PMehOutlined.js
// module id = 3509
// module chunks = 0